import * as LucideIcons from 'lucide-react';

interface ProductAdvantage {
  icon: string;
  title: string;
  description: string;
}

interface ProductFeaturesProps {
  productAdvantages?: ProductAdvantage[];
}

const defaultAdvantages: ProductAdvantage[] = [
  { 
    icon: "Leaf",
    title: "Healthy Plants", 
    description: "Quality guaranteed" 
  },
  { 
    icon: "Truck",
    title: "Free Delivery", 
    description: "Pan India shipping" 
  },
  { 
    icon: "HeartHandshake",
    title: "Plant Care Support", 
    description: "Expert guidance" 
  },
];

export const ProductFeatures = ({ productAdvantages }: ProductFeaturesProps) => {
  const features = productAdvantages && productAdvantages.length > 0 ? productAdvantages : defaultAdvantages;

  const getIcon = (iconName: string) => {
    const Icon = (LucideIcons as any)[iconName] || LucideIcons.Circle;
    return <Icon className="h-6 w-6 md:h-8 md:w-8" />;
  };

  return (
    <div className="mt-6 border-t border-b border-border py-6">
      <h3 className="text-lg md:text-xl font-semibold mb-4 text-foreground">Paudhify Advantages</h3>
      <div className="grid grid-cols-3 gap-3 md:gap-4 text-center">
        {features.map((feature, index) => (
          <div key={index} className="flex flex-col items-center">
            <div className="mb-2 md:mb-3 w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-muted/30 rounded-full">
              {getIcon(feature.icon)}
            </div>
            <p className="font-medium text-xs md:text-sm leading-tight">{feature.title}</p>
            <p className="text-xs md:text-sm text-muted-foreground mt-1 leading-tight">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
